'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFlower = function IoIosFlower(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 17.8c4.3 0 6.6 1 6.6 2.2s-2.3 2.2-6.6 2.2c-2.3 0-5.1-0.6-7.3-1.1-0.1 0.2-0.2 0.5-0.3 0.7 1.9 1.2 4.4 2.8 5.9 4.4 3.1 3.1 4.2 5.3 3.2 6.2s-3.1-0.1-6.2-3.2c-1.6-1.5-3.2-4-4.4-5.9-0.2 0.1-0.5 0.2-0.8 0.3 0.6 2.2 1.2 5 1.2 7.3 0 4.3-1 6.6-2.2 6.6s-2.2-2.3-2.2-6.6c0-2.3 0.6-5.1 1.2-7.3-0.3-0.1-0.6-0.2-0.8-0.3-1.2 1.9-2.8 4.4-4.4 5.9-3.1 3.1-5.3 4.2-6.2 3.2s0.1-3.1 3.2-6.2c1.5-1.6 4-3.2 5.9-4.4-0.1-0.2-0.2-0.5-0.3-0.7-2.2 0.5-5 1.1-7.3 1.1-4.3 0-6.6-0.9-6.6-2.2s2.3-2.2 6.6-2.2c2.3 0 5.1 0.6 7.3 1.2 0.1-0.2 0.2-0.6 0.3-0.8-1.9-1.2-4.4-2.7-5.9-4.3-3.1-3.1-4.2-5.3-3.2-6.2s3.1 0 6.2 3.1c1.6 1.5 3.2 4 4.4 5.9 0.2-0.1 0.5-0.2 0.7-0.3-0.5-2.2-1.1-5-1.1-7.3 0-4.3 0.9-6.6 2.2-6.6s2.2 2.3 2.2 6.6c0 2.3-0.6 5.1-1.1 7.3 0.2 0.1 0.5 0.2 0.7 0.3 1.2-1.9 2.8-4.4 4.4-5.9 3.1-3.1 5.3-4.1 6.2-3.1s-0.1 3.1-3.2 6.2c-1.5 1.6-4 3.1-5.9 4.3 0.1 0.2 0.2 0.6 0.3 0.8 2.2-0.6 5-1.2 7.3-1.2z m-7.8 9.9s1.9 2.6 3.9 4c0.7 2.7 0.5 4.2-0.4 4.5-0.2 0.1-0.3 0.1-0.4 0.1-0.9 0-2-1-2.9-2.7 0.4-2.7-0.2-5.9-0.2-5.9z m-6.3-15.4s-2.1-2.7-3.8-3.9c-0.7-2.8-0.5-4.3 0.4-4.7 0.2 0 0.3 0 0.4 0 0.9 0 1.9 0.9 2.9 2.8-0.5 2.7 0.1 5.8 0.1 5.8z m-4.5 10.9s-2.6 1.9-3.9 3.8c-1 0.3-2.1 0.4-2.8 0.4-1 0-1.6-0.3-1.8-0.8-0.4-0.9 0.5-2 2.6-3.2 2.7 0.3 5.9-0.2 5.9-0.2z m15.4-6.3s2.5-2 3.9-3.9c1.1-0.3 2.1-0.3 2.8-0.3 1 0 1.6 0.2 1.8 0.7 0.4 0.9-0.5 2.1-2.6 3.3-2.7-0.4-5.9 0.2-5.9 0.2z m-15 15.1c2.5-1.9 4.2-4.3 4.2-4.3s-0.6 3-0.3 5.5c-1.1 2-2.1 3-3 3-0.2 0-0.3 0-0.5 0-0.8-0.4-1-1.9-0.4-4.2z m14.6-23.9c-2.3 1.7-4.2 4.3-4.2 4.3s0.6-3.7 0.3-5.5c1-2 2.1-3.1 3-3.1 0.2 0 0.3 0 0.5 0.1 0.8 0.4 1 1.7 0.4 4.2z m-20.4 8.5c-2.2-1.1-3.4-2.5-3-3.4 0.2-0.5 0.8-0.9 1.7-0.9 0.6 0 1.7 0.1 2.4 0.4 1.5 1.9 4.3 4.2 4.3 4.2s-3.1-0.6-5.4-0.3z m26.2 6.8c2.4 1.3 3.4 2.5 3 3.5-0.2 0.5-0.8 0.8-1.7 0.8-0.7 0-1.5-0.1-2.4-0.4-1.6-2.1-4.3-4.1-4.3-4.1s3.5 0.6 5.4 0.2z' })
        )
    );
};

exports.default = IoIosFlower;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-flower.js
// module id = 2163
// module chunks = 0